import { createAsyncThunk } from '@reduxjs/toolkit';

import { TLocale } from './i18n.declarations';
import { loadI18n } from './i18n.helpers';

export const thunkI18nClients = createAsyncThunk<
  any,
  { project_id: string; languages: Array<TLocale>; translations: Record<string, any>; projectName: string; defaultLanguage: TLocale }
>('i18n/module-clients', async ({ project_id, languages, translations, projectName, defaultLanguage }, thunkAPI) => {
  try {
    await loadI18n({
      projectId: project_id,
      languages,
      translations,
      moduleName: 'clients',
      projectName,
      defaultLanguage,
    });
    return thunkAPI.fulfillWithValue('i18n Loaded');
  } catch (error) {
    return thunkAPI.rejectWithValue({ error });
  }
});

export const thunkI18nCalendar = createAsyncThunk<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  {
    project_id: string;
    languages: Array<TLocale>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    translations: Record<string, any>;
    projectName: string;
    defaultLanguage: TLocale;
  }
>('i18n/module-calendar', async ({ project_id, languages, translations, projectName, defaultLanguage }, thunkAPI) => {
  try {
    await loadI18n({
      projectId: project_id,
      languages,
      translations,
      moduleName: 'calendar',
      projectName,
      defaultLanguage,
    });
    return thunkAPI.fulfillWithValue('i18n Loaded');
  } catch (error) {
    return thunkAPI.rejectWithValue({ error });
  }
});
